<template>
  <div class="bar_chart_wrap">
    <v-tooltip color="#202126" top>
      <template #activator="{ on, attrs }">
        <div class="chart_info" v-bind="attrs" v-on="on">
          <div>오늘의 구강건강순위</div>
          <div v-if="comparison.rank" class="rank_text">
            <span v-if="type === 'report'">{{ comparison.rank }} / {{ `${comparison.totalHeadcount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</span>
            <span v-else>{{ comparison.rank }}</span>
            등
          </div>
          <div v-else class="no_rank_text">미촬영</div>
        </div>
      </template>
      <span v-if="comparison.percent">상위 {{ comparison.percent }}%</span>
      <span v-else>미촬영</span>
    </v-tooltip>
    <div class="bar_chart_box d-flex">
      <bar-chart v-if="chartData.datasets[0].data.length !== 0" :width="type === 'report' ? 460 : 250" :height="180" :chart-data="chartData" :options="options"></bar-chart>
      <div v-if="!comparison.soldierState" class="graph_replace_img"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BarChart from '@/components/chart/BarChart';

export default {
  name: 'StatusBarChart',
  components: {
    BarChart,
  },
  props: {
    comparison: {
      type: Object,
      default: () => {
        return {
          rank: 0,
          percent: 0,
          soldierState: '',
          corpsState: '',
          corpsHeadcount: 0,
          totalState: '',
          totalHeadcount: 0,
        };
      },
    },
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    chartData: {
      labels: [],
      datasets: [
        {
          data: [],
          backgroundColor: [],
          barThickness: 40,
        },
      ],
    },
    options: {
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: 30,
        },
      },
      scales: {
        xAxes: [
          {
            ticks: {
              fontSize: 12,
              fontColor: '#7f848e',
            },
            gridLines: {
              display: false,
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              display: false,
            },
            gridLines: {
              display: false,
            },
          },
        ],
      },
      legend: {
        display: false,
      },
      tooltips: {
        backgroundColor: '#202126',
        xPadding: 30,
        yPadding: 10,
        bodyFontSize: 14,
        displayColors: false,
        caretSize: 0,
      },
    },
  }),
  computed: {
    ...mapState('commonValue', ['healthStatus']),
  },
  watch: {
    comparison: function () {
      this.setChart();
    },
  },
  created() {
    this.setChart();
  },
  methods: {
    setChart() {
      this.chartData.labels.push(this.name, '내 부대', '내 지역');
      this.chartData.datasets[0].data.push(this.comparison.soldierState ? this.healthStatus[this.comparison.soldierState].value : 0);
      this.chartData.datasets[0].data.push(this.comparison.corpsState ? this.healthStatus[this.comparison.corpsState].value : 0);
      this.chartData.datasets[0].data.push(this.comparison.totalState ? this.healthStatus[this.comparison.totalState].value : 0);
      this.chartData.datasets[0].backgroundColor.push(this.comparison.soldierState ? this.healthStatus[this.comparison.soldierState].color : '#000', '#dadee6', '#dadee6');
      const tooltipLabels = [
        this.comparison.soldierState ? this.healthStatus[this.comparison.soldierState].text : '',
        this.comparison.corpsState ? this.healthStatus[this.comparison.corpsState].text : '',
        this.comparison.totalState ? this.healthStatus[this.comparison.totalState].text : '',
      ];
      this.options.tooltips.callbacks = {
        title: function () {
          return '';
        },
        label: function (tooltipItem) {
          return tooltipLabels[tooltipItem.index];
        },
      };
      const barLabels = [this.comparison.soldierState ? this.healthStatus[this.comparison.soldierState].text : '', `${this.comparison.corpsHeadcount}`, `${this.comparison.totalHeadcount}`];
      this.options.plugins = {
        datalabels: {
          align: context => (context.dataIndex === 0 ? 'center' : 'end'),
          offset: 0,
          anchor: context => (context.dataIndex === 0 ? 'center' : 'end'),
          color: context => (context.dataIndex === 0 ? '#fff' : '#7f848e'),
          clamp: true,
          font: {
            weight: 'normal',
          },
          display: function (context) {
            return context.dataset.data[context.dataIndex] > 0;
          },
          formatter: function (value, context) {
            if (context.dataIndex === 0) {
              return barLabels[context.dataIndex];
            } else {
              return `${barLabels[context.dataIndex].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}명`;
            }
          },
        },
      };
      if (this.type === 'report') {
        this.options.plugins.datalabels.font.size = 16;
        this.options.scales.xAxes[0].ticks.fontSize = 16;
      }
    },
  },
};
</script>

<style scoped>
.bar_chart_wrap {
  width: 100%;
}
.chart_info {
  text-align: center;
}
.no_rank_text {
  color: #656e81;
  font-size: 32px;
}
.bar_chart_box {
  position: relative;
}
.graph_replace_img {
  position: absolute;
  width: 56px;
  height: 58px;
  background-image: url('../../assets/img/common/graph_replace_img.png');
  bottom: 30px;
  left: 20px;
}
</style>
